export default "__VITE_ASSET__DdC58Klp__"